import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Review from './review/index.js';
import Visualizer from './visualizer';
import { Button } from '@ifixit/toolbox';
import { space } from '@core-ds/primitives';
import { _js } from '@ifixit/localize';
var breakpointSm = '@media screen and (max-width: 650px)';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   display: flex;\n   justify-content: space-between;\n   align-items: flex-start;\n\n   ", " {\n      // Switch to non-flex because IE11 and column mode don't\n      // play well.\n      display: block;\n      margin: auto;\n   }\n"])), breakpointSm);
var ReviewsContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   flex: 1;\n   margin-left: 18px;\n\n   ", ";\n\n   ", " {\n      padding-left: 0;\n      margin-left: 0;\n   }\n"])), function (props) {
  return props.noReviews && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n         display: flex;\n         justify-conent: center;\n         align-items: center;\n         padding-left: ", ";\n         min-height: 70px;\n      "])), space[5]);
}, breakpointSm);
var NoReviewsText = styled.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var ShowMore = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n   margin: 24px 0;\n"]))); // Number of reviews that are revealed each time "Show More" is clicked.

var increment = 3;

var ProductReviews = /*#__PURE__*/function (_Component) {
  _inherits(ProductReviews, _Component);

  var _super = _createSuper(ProductReviews);

  function ProductReviews() {
    var _this;

    _classCallCheck(this, ProductReviews);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      itemLimit: increment
    };

    _this.showMore = function () {
      _this.setState(function (prevState) {
        return {
          itemLimit: prevState.itemLimit + increment
        };
      });
    };

    return _this;
  }

  _createClass(ProductReviews, [{
    key: "reviewsWithText",
    get: function get() {
      var reviews = this.props.productReviews.reviews;
      return reviews.filter(function (review) {
        return review.body || review.headline;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          itemcode = _this$props.itemcode,
          productReviews = _this$props.productReviews,
          reviewsLink = _this$props.reviewsLink;
      var reviewsUrl = reviewsLink && itemcode && "".concat(reviewsLink, "/").concat(itemcode);
      var itemLimit = this.state.itemLimit;
      var reviewsWithText = this.reviewsWithText;
      var noReviews = reviewsWithText.length === 0;
      return /*#__PURE__*/React.createElement(Container, {
        id: "productReviews"
      }, /*#__PURE__*/React.createElement(Visualizer, {
        productReviews: productReviews,
        reviewsUrl: reviewsUrl
      }), /*#__PURE__*/React.createElement(ReviewsContainer, {
        noReviews: noReviews
      }, noReviews && /*#__PURE__*/React.createElement(NoReviewsText, null, _js('No comments to show yet')), reviewsWithText.map(function (review, index) {
        if (index < itemLimit) {
          return /*#__PURE__*/React.createElement(Review, {
            key: "".concat(review.author.name, "-").concat(index),
            review: review,
            showBorder: reviewsWithText.length > 1 && index < reviewsWithText.length - 1,
            reviewsUrl: reviewsUrl
          });
        }

        return null;
      }), itemLimit < reviewsWithText.length && /*#__PURE__*/React.createElement(ShowMore, null, /*#__PURE__*/React.createElement(Button, {
        fullWidth: true,
        onClick: this.showMore
      }, _js('Show %1 more', itemLimit < reviewsWithText.length - increment ? increment : reviewsWithText.length - itemLimit)))));
    }
  }]);

  return ProductReviews;
}(Component);

export default ProductReviews;